import { createApi } from '@reduxjs/toolkit/query/react';
import { v4 as uuidv4 } from 'uuid';
import { TagTypes } from '../constants/api.constants';
import request from '../utils/request';
import RTKRequestService from '../services/RTKRequestService';

async function axiosBaseQuery(reqPayload, api, extraOptions) {
  const requestId = uuidv4();
  const takeLatest = !!extraOptions?.takeLatest;

  const abortController = RTKRequestService.addRequest(
    requestId,
    window.location.pathname,
    api.endpoint,
    takeLatest,
  );

  return request({ ...reqPayload, signal: abortController.signal })
    .finally(() => {
      RTKRequestService.removeRequest(requestId);
    })
    .then(response => {
      const rtkResponse = { data: response.results };

      if (response.headers) {
        rtkResponse.meta = {
          headers: response.headers,
        };
      }

      return rtkResponse;
    })
    .catch(error => {
      return {
        error: abortController.signal.aborted ? { ...error, canceled: true } : error,
      };
    });
}

const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery,
  tagTypes: Object.values(TagTypes),
  keepUnusedDataFor: 0,
  endpoints: () => ({}),
});

export default baseApi;
